// 枚举项class
class EnumItem {
  constructor (object) {
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        this[key] = object[key]
      }
    }
  }
  equal (keyOrValue) {
    return this.key === keyOrValue || this.value === keyOrValue
  }
}
EnumItem.prototype.valueOf = function () {
  return this.value
}
// 枚举class
class Enum {
  constructor (enumArr) {
    this._enum = {}
    for (const item of enumArr) {
      this._enum[item.key] = new EnumItem(item)
      Object.defineProperty(this, item.key, {
        value: this._enum[item.key]
      })
    }
  }
  getEnum () {
    return this._enum
  }
  get (keyOrValue) {
    if (this._enum[keyOrValue] !== undefined) {
      return this._enum[keyOrValue]
    } else {
      for (const key in this._enum) {
        if (this._enum.hasOwnProperty(key)) {
          if (keyOrValue === this._enum[key].value) {
            return this._enum[key]
          }
        }
      }
      return null
    }
  }
  getName (keyOrValue) {
    const tempEnum = this.get(keyOrValue)
    return tempEnum ? tempEnum.name : null
  }
  valueIsIn (value, keyOrValues = []) {
    let temp
    for (const keyOrValue of keyOrValues) {
      temp = this.get(keyOrValue)
      if (temp && temp.value === value) {
        return true
      }
    }
    return false
  }
  valueIsNotIn (value, keyOrValues = []) {
    let temp
    for (const keyOrValue of keyOrValues) {
      temp = this.get(keyOrValue)
      if (temp && temp.value === value) {
        return false
      }
    }
    return true
  }
}
Enum.prototype.valueOf = function () {
  return this._enum
}
export const MAJOR_TYPE = new Enum([
  {key: 'JUNIOR_COLLEGE', value: 0, name: '专科'},
  {key: 'UNDERGRADUATE', value: 1, name: '本科'}
])
export const ROLE = new Enum([
  {key: 'ROLE_SYSTEMMANAGER', value: 'ROLE_SYSTEMMANAGER', name: '系统管理员'},
  {key: 'ROLE_CHANNEL_ADMIN', value: 'ROLE_CHANNEL_ADMIN', name: '合作渠道管理员'},
  // {key: 'ROLE_CHANNEL_USER', value: 'ROLE_CHANNEL_USER', name: '合作渠道用户'},
  {key: 'ROLE_CHANNEL_ONE', value: 'ROLE_CHANNEL_ONE', name: '一级代理'},
  {key: 'ROLE_CHANNEL_TWO', value: 'ROLE_CHANNEL_TWO', name: '二级代理'}
])
export const FORECAST_TYPE = new Enum([
  {key: 'PRE_ENROLL', value: 0, name: '预报名信息'},
  {key: 'ENROLL', value: 1, name: '报名信息'}
])
export const CHANNEL_TYPE = new Enum([
  {key: 'COMPANY_OR_GROUP', value: 0, name: '企业或团体'},
  {key: 'PERSON', value: 1, name: '个人'}
])
export const CONTRACT_TYPE = [
  {name: '业余制合同', value: 0},
  {name: '业余制独家合同', value: 1},
  {name: '个人业余制合同', value: 2},
  {name: '全日制合同', value: 3}
]
export const INFOR_TYPE = new Enum([
  {key: 'WEIIXN', value: 0, name: '微信'},
  {key: 'BAIDU', value: 1, name: '百度'},
  {key: 'HEADLINES', value: 2, name: '今日头条'}
])
export const CONSULT_TYPE = new Enum([
  {key: 'FULL_TIME', value: 0, name: '全日制'},
  {key: 'PART_TIME', value: 1, name: '业余制'},
  {key: 'ADULT', value: 1, name: '成教'}
])
export const CONSULT_STATUS = new Enum([
  {key: 'FIRST_CONSULT', value: 0, name: '首次咨询'},
  {key: 'FOLLOW', value: 1, name: '正在跟进'},
  {key: 'PAID', value: 2, name: '已交定位费'},
  {key: 'ENROLLED', value: 3, name: '已报名'},
  {key: 'ABANDONED', value: 4, name: '已放弃'}
])
export const GENDER = new Enum([
  {key: 'MALE', value: 1, name: '男'},
  {key: 'FEMALE', value: 0, name: '女'}
])
export const CHANNEL_GRADE = new Enum([
  {key: 'ADMIN', value: 0, name: '渠道管理员'},
  {key: 'ONE', value: 1, name: '一级代理'},
  {key: 'TWO', value: 2, name: '二级代理'}
  // {key: 'OTHER', value: 2, name: '其他'}
])
export const DATE_TYPE = new Enum([
  {key: 'DAY', value: 0, name: '按天统计'},
  {key: 'WEEK', value: 1, name: '按周统计'},
  {key: 'MONTH', value: 2, name: '按月统计'},
  // {key: 'SEASON', value: 3, name: '按季度统计'},
  {key: 'YEAR', value: 4, name: '按年统计'}
])
export const SMS_TYPE = new Enum([
  {key: 'REG', value: 0, name: '注册'},
  {key: 'RESET_PASSWORD', value: 1, name: '修改/重置密码'}
])
export const MSG_TYPE = new Enum([
  {key: 'SYSTEM', value: 0, name: '系统消息'},
  {key: 'OTHER', value: 1, name: '其他消息'}
])
export const MSG_CONTENT_TYPE = new Enum([
  {key: 'PAY', value: 0, name: '缴费内容'},
  {key: 'EXAM', value: 1, name: '报考内容'},
  {key: 'OTHER', value: 2, name: '其他内容'},
  {key: 'COURSE_CONTENT_UPDATE', value: 3, name: '课程内容更新'}
])
export const MSG_CONTENT_TYPE_FOR_ADD = new Enum([
  {key: 'EXAM', value: 1, name: '报考内容'},
  {key: 'OTHER', value: 2, name: '其他内容'}
])
export const MSG_RECV_TYPE = new Enum([
  {key: 'CLASS', value: 0, name: '班级'},
  // {key: 'GRADE', value: 1, name: '年级'},
  {key: 'PERSON', value: 2, name: '学生'}
  // {key: 'COURSE', value: 3, name: '课程'},
  // {key: 'OTHER', value: 4, name: '其他'}
])
export const CLASS_AND_GRADE_STATUS = new Enum([
  {key: 'UNDIVIDED', value: 0, name: '未分班'},
  {key: 'DIVIDED', value: 1, name: '已分班'}
])
export const CHANNEL_DETAIL_STATISTICS_TYPE = new Enum([
  {key: 'BY_MAJOR', value: 0, name: '按专业统计'},
  {key: 'BY_CHANNEL', value: 1, name: '按渠道统计'}
])
export const PAY_STATUS = new Enum([
  {key: 'PAY_NO', value: 0, name: '未支付'},
  {key: 'PAY_SUCCESS', value: 1, name: '支付成功'},
  {key: 'PAY_FAILED', value: 2, name: '支付失败'}
])



// WEBPACK FOOTER //
// ./src/utils/enum.js